<template >
    <div class='row'>
        
        <fieldset>
            <legend>Trabalhos do edital anterior da SIAC</legend>
            <div class="col s12" v-if="message == undefined">
                <base-collapsible 
                    v-for="(trabalho, index) in trabalhos" 
                    :key="index">
                    <span slot='collapsible-header'>
                        {{trabalho.titulo}}
                        <i class="large material-icons">expand_more</i>
                    </span>
                    <div class="row" slot='collapsible-body'>
                       <div class="col s12 detalhes">
                           <span>Autores:</span>
                           <ol>
                               <li
                               v-for="(autor,index) in stringToArray(trabalho.autores)"
                                :key="index">
                                        {{autor}}
                                </li>
                           </ol>
                           
                         
                       </div>
                       <div class="col s12 detalhes">
                           <span>Orientadores:</span>
                           <ol>
                               <li
                                v-for="(orientador,index) in stringToArray(trabalho.orientadores)"
                                :key="index">
                                        {{orientador}}
                                </li>
                           </ol>
                       </div>
                        <div class="col s12 detalhes">
                           Modalidade de Participação: {{trabalho.modalidade_participacao}}
                       </div>
                        <div class="col s12 detalhes">
                           Área de Conhecimento: {{trabalho.area_conhecimento}}
                       </div>
                        <div class="col s12 detalhes">
                           Área Temática: {{trabalho.area_tematica}}
                       </div>
                        <div class="col s12 detalhes">
                           Modalidade de Apresentação: {{trabalho.modalidade_apresentacao}}
                       </div>
                        <div class="col s12 detalhes">
                           Apresentado: {{trabalho.trabalho_apresentado == "P"?"Sim":"Não"}}
                        </div>
                    </div>
                </base-collapsible>                
            </div>
            <div class="col s12" v-else>
                <div class= "card-panel amber lighten-3">
                    <span>
                        {{message}}
                    </span>
                </div>
            </div>        
    
            
        </fieldset>
    
        
    </div>
</template>
<script>
import { mapState } from 'vuex';
import BaseCollapsible from './BaseCollapsible.vue';

export default {
  components: { BaseCollapsible },
    name: 'GrupoSiac',
    data(){
       return{
            trabalhos: [],
            message : undefined
        };
    },
    computed:{
        ...mapState(['project']),
        
    },
    methods:{
        stringToArray(str){
			if (str)
				return str.split(",");
			return null;
        },
        async getTrabalhosByCpf(){
            try {
                let cpf = this.project.curriculo.usuario.cpf;
                let tipo = this.project.curriculo.edital.siac_anterior;
                
                let {data} = await this.$http.get(`/api/siac/${cpf}/${tipo}`);
                this.$set(this,'message',data['message']);
                let result = data['result'];
                this.$set(this,'trabalhos',result);
                    
            } catch (error) {
                console.error(error);
            }
            
        }
    },
    async mounted(){
        await this.getTrabalhosByCpf();
    }
}

</script>
<style scoped>
    .detalhes{
        padding-bottom: 5px;
        padding-top: 5px;
    }
</style>